@import 'styles/mixins';
@import 'styles/blaze/mixins';

.instagramStoryLoadingPreview {
  border-radius: 20px;
  border: 1px solid var(--dark-8);
  background: var(--light-100);
  box-shadow: 0px 20px 80px 0px var(--dark-10);
  display: flex;
  flex-direction: column;

  .header {
    margin-bottom: 20px;
    padding: 14px 18px 0 18px;
    position: relative;

    .row {
      display: flex;
      align-items: center;
      gap: 5px;

      :global .ant-skeleton-active {
        width: auto !important;
      }

      .second {
        :global .ant-skeleton {
          li {
            border-radius: 90px;
            height: 10px !important;
            margin-top: 0 !important;
          }
        }
      }
    }

    .storyLine {
      width: 100%;
      height: 2px;
      background: var(--dark-4);
      margin-bottom: 10px;
    }

    .storyLineLoaded {
      position: absolute;
      top: 14px;
      width: 130px;
      height: 2px;
      background: var(--dark-4);
    }

    :global .ant-skeleton {
      .ant-skeleton-paragraph {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 7px 0;

        li {
          border-radius: 90px;
          margin-top: 0 !important;
          height: 10px;
        }
      }
    }
  }

  .body {
    @include blur(5px);
    height: 540px;
    opacity: 0.4;
    background: linear-gradient(180deg, var(--light-100) 0%, var(--brand-kit-color) 100%);
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 12px;
    gap: 8px;
    width: 100%;

    :global .ant-skeleton {
      .ant-skeleton-header {
        padding: 0 !important;
      }

      .ant-skeleton-paragraph {
        display: flex;
        flex-direction: column;

        li {
          border-radius: 90px;
          margin-top: 0 !important;
          height: 33px;
        }
      }
    }
  }
}
